import React from 'react'
import _ from 'lodash'
import CarePlanSummaryHeader from '../../../../../../components/carePlans/CarePlanSummaryHeader'
import styles from '../../CarePlanReiviewForm.styles'
import { Carer, CarePlan, Log, Resident, CarePlanAdl } from '@lmc/ts-common'

type SetFormField = {
  key: string
  value: string | number | string[] | boolean
}

// @ts-ignore
export interface ICarePlanForm extends CarePlan {
  carePlanAdl?: CarePlanAdl
}

interface ICarePlanReviewHeader {
  carers: Carer[]
  errors: string[]
  signatureLogs?: Log[]
  setFormField: (update: SetFormField) => void
  carePlanNominative: string
  handleCancel: () => void
  resident: Resident
  fields: ICarePlanForm
  FORM_ID: string
}

export const CarePlanReviewHeader = ({
  carers,
  errors,
  signatureLogs,
  setFormField,
  carePlanNominative,
  handleCancel,
  resident,
  fields,
  FORM_ID,
}: ICarePlanReviewHeader): React.ReactElement => {
  const editedBy = _.find(carers, { id: fields.editedBy })
  return (
    <div style={styles.headerContainer}>
      <CarePlanSummaryHeader
        carePlan={fields as any}
        carer={editedBy}
        errors={errors}
        fields={fields}
        logs={signatureLogs}
        setFormField={setFormField}
        formId={FORM_ID}
        onClickBack={handleCancel}
        resident={resident}
        carePlanNominative={carePlanNominative}
      />
    </div>
  )
}

export default CarePlanReviewHeader
